import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';

/**
 * This class has to be extended and overriden
 * on the application using formrenderer library.
 */
@Injectable({
  providedIn: 'root',
})
export class BaseTranslationService {
  public translateText(text: string): Observable<string> {
    text =
      'This is a mock text! \nLorem ipsum dolor sit amet, consectetur adipiscing elit. Ut ac aliquam mauris. Phasellus tempor libero vitae mi commodo, vitae sollicitudin odio halloj.';
    return of(text).pipe(delay(1000));
  }
}
